import StringInput from './stringInput';
import TextAreaInput from './textAreaInput';
import { ItemField, ItemPicker, MultiItemSelect } from '../itemField';
import NumerInput from './numberInput';
import Selector from './selector';
import TextInput from './textInput';
import DateInput from './dates';
import Multiselector from './multiselector';
import MultiVaueInput from './multiValue';
// eslint-disable-next-line import/no-cycle
import FormatInput from './format';
import Radio from './radio';
import { withEditor } from './withEditor';
import EditorChekboxInput from './EditorCheckbox';

const EditorControls = {
  StringInput: withEditor()(StringInput),
  TextAreaInput: withEditor()(TextAreaInput),
  ItemPicker: withEditor()(ItemPicker),
  MultiItemSelect: withEditor()(MultiItemSelect),
  ItemField: withEditor()(ItemField),
  NumerInput: withEditor()(NumerInput),
  Selector: withEditor()(Selector),
  TextInput: withEditor()(TextInput),
  DateInput: withEditor({ shrink: true })(DateInput),
  CheckboxInput: EditorChekboxInput,
  Radio: withEditor({ shrink: true })(Radio),
  Multiselector: withEditor()(Multiselector),
  MultiVaueInput: withEditor()(MultiVaueInput),
  FormatInput: withEditor()(FormatInput),
};

export default EditorControls;
